<template>
  <div>
    <ContentCourseConfirm
      v-if="keyName === 'course_confirm'"
    />
    <ContentStoreSelect
      v-else-if="keyName === 'store_select'"
    />
    <ContentTieUpConfirm
      v-else-if="keyName.startsWith('tie_up_confirm_')"
      :contents="contents"
      :custom-id="keyName.slice('tie_up_confirm_'.length)"
    />
    <ContentOffHourStore
      v-else-if="keyName === 'off_hour_store'"
    />
    <OffHourNationalShipping
      v-else-if="keyName === 'off_hour_national_shipping'"
      :contents="contents"
    />
    <!-- keyName、contents を使って自由にコードを書ける -->
    <div v-else class="rounded-xl border-dashed border-2 border-blue-500">
      <div class="text-center" :style="{ marginTop: '-0.75rem' }">
        <span class="bg-white text-blue-500 font-bold px-2 rounded">
          このコンテンツは未実装（キー名: {{ keyName || '（未設定）' }}）
        </span>
      </div>
      <Content
        v-for="(content, index) in contents"
        :key="index"
        :content="content"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, PropType } from 'vue';

import ContentCourseConfirm from '@/components/ContentCourseConfirm.vue';
import ContentTieUpConfirm from '@/components/ContentTieUpConfirm.vue';
import { ContentBase } from '@/models/content_base';

import ContentOffHourStore from './ContentOffHourStore.vue';
import ContentStoreSelect from './ContentStoreSelect.vue';
import OffHourNationalShipping from './OffHourNationalShipping.vue';

export default defineComponent({
  name: 'ContentCustomizing',
  components: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Content: defineAsyncComponent((): any => import('./Content.vue')),
    ContentCourseConfirm,
    ContentTieUpConfirm,
    ContentOffHourStore,
    OffHourNationalShipping,
    ContentStoreSelect,
  },
  props: {

    /**
     * キー名
     */
    keyName: {
      type: String,
      required: true,
    },

    /**
     * コンテンツ
     */
    contents: {
      type: Array as PropType<ContentBase[]>,
      required: true,
    },
  },
});
</script>
